import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { filter, first, map, tap } from 'rxjs/operators';

import { Store } from '@ngrx/store';

import { DevicesOsUpdateStatusActions, DevicesOsUpdateStatusStates } from './index';
import { LocationsRouterStoreSelectors, RouterStoreStates } from '../../../../stores/router';

@Injectable()
export class DevicesOsUpdateStatusResolver {
  constructor(
    private readonly routerStore: Store<RouterStoreStates.RouterState>,
    private readonly osUpdatesStore: Store<DevicesOsUpdateStatusStates.DeviceOsUpdateStatusState>
  ) {}

  resolve(): Observable<boolean> {
    return this.routerStore.select(LocationsRouterStoreSelectors.selectLocationId).pipe(
      filter((locationId) => !!locationId),
      tap((locationId) => {
        this.osUpdatesStore.dispatch(
          DevicesOsUpdateStatusActions.DevicesOsUpdateStatesResolverActions.osUpdateStatesRequested({
            locationId,
          })
        );
      }),
      map(() => true),
      first()
    );
  }
}
